import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../services/seo.service';
import { EmailJsService } from '../../services/emailjs.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-petitions',
  standalone: true,
  templateUrl: './petitions.component.html',
  styleUrls: ['./petitions.component.css'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule]
})
export class PetitionsComponent implements OnInit {
  constructor(private seo: SeoService, private emailJsService: EmailJsService) {}

  ngOnInit(): void {
    this.seo.update(
      'Sign the Pledge',
      'Sign the pledge to help Lydia win Michigan as the Libertarian Party nominee for U.S. Senate. We need 15,000 doors knocked by November 3, 2026.',
      'petitions'
    );
  }

  signatures = 8000;
  goal = 15000;
  petition = { name: '', email: '', zip: '' };
  petitionSubmitted = false;
  isSubmitting = false;
  errorMessage = '';

  get progressPct(): number {
    return Math.min(100, Math.round((this.signatures / this.goal) * 100));
  }

  async onPetitionSubmit(): Promise<void> {
    this.isSubmitting = true;
    this.errorMessage = '';
    try {
      await this.emailJsService.sendEmail(
        { ...this.petition, message: 'Online GOTV pledge' },
        'Voter Pledge'
      );
      this.petitionSubmitted = true;
    } catch (err) {
      this.errorMessage = 'Failed to submit. Please try again or email senator@lydialynnchristensen.com.';
      console.error(err);
    } finally {
      this.isSubmitting = false;
    }
  }

  resetPetitionForm(): void {
    this.petition = { name: '', email: '', zip: '' };
    this.petitionSubmitted = false;
    this.errorMessage = '';
  }
}
